import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./progressRing.html";
import { TECH_TYPE_ICON_MAP } from '~/modules/utilities/schemaUtilities';
class ProgressRing extends LightningElement {
  constructor(...args) {
    super(...args);
    this.type = 'default';
    this.percentage = 0;
    this.published = false;
    this.failed = false;
  }
  get styleClass() {
    var _TECH_TYPE_ICON_MAP$t;
    return (_TECH_TYPE_ICON_MAP$t = TECH_TYPE_ICON_MAP[this.type]) !== null && _TECH_TYPE_ICON_MAP$t !== void 0 ? _TECH_TYPE_ICON_MAP$t : 'force';
  }
  get percentageCircle() {
    return this.percentage.toString() + ', 100';
  }
  get styleCircle() {
    return 'circular-chart ' + this.type;
  }
  get notStarted() {
    return this.percentage === 0;
  }
  get inProgress() {
    return this.percentage > 0 && this.percentage <= 100 && !this.published && !this.failed;
  }
  get completed() {
    return this.percentage === 100 && this.published === true;
  }
  get x_percentage() {
    if (this.percentage < 100) {
      return 24.5;
    }
    return 27.8;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ProgressRing, {
  publicProps: {
    type: {
      config: 0
    },
    percentage: {
      config: 0
    },
    published: {
      config: 0
    },
    failed: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ProgressRing, {
  tmpl: _tmpl,
  sel: "appx-progress-ring",
  apiVersion: 62
});
export default __lwc_component_class_internal;